import { PatientTableInfoEntity } from "@/domain/entity/patient/patient-table-info-entity";
import { PatientRepository } from "@/domain/repository/patient-repository";
import { SATError, SATResult } from "@sadtx/sat-error";

export class FetchPatientUsecase {
  //MARK: - Constructor
  constructor(private readonly patientRepository: PatientRepository) {}

  async execute(patientUuid: string): Promise<SATResult<PatientTableInfoEntity, SATError>> {
    return this.patientRepository.fetchPatient(patientUuid);
  }
}
